import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { trackOwnerManualFolderClick } from 'tw-oi-core/services/analytics'

import { MESSAGE, ROUTE } from '../config'
import {
  OWNERS_MANUAL_TITLE,
  getPublicationsForVehicle,
  getArticlesWithTags,
  getContentByTag,
  getUniqueTags,
  compareNumberedStrings,
  tagToRenderItem,
} from '../extras/utils'

import BrowseGuideLayout from '../components/BrowseGuideLayout'
import ContentList from '../components/ContentList'
import { browseListIcon } from '../components/browseListIcon'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'

import '../styles/Topics.scss'

const ArticlesTags = ({ articles, match, baseRoute }) => {
  const items = useMemo(() => {
    const tag = decodeURIComponent(match.params.tag)
    const tags = getUniqueTags(tag ? getContentByTag(tag, articles) : articles)

    return tags
      .filter(x => x !== OWNERS_MANUAL_TITLE)
      .sort(compareNumberedStrings)
      .map(tagToRenderItem)
      .map(item => ({
        ...item,
        link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.ARTICLES}/${encodeURIComponent(item.title)}`,
        icon: browseListIcon(FolderOutlinedIcon),
      }))
  }, [articles, match, baseRoute])

  return (
    <BrowseGuideLayout match={match} baseRoute={baseRoute}>
      {({ filterBrowseMenuItems, offlineBrowseActive }) => (
        <ContentList
          variant='browse-guide'
          topics={offlineBrowseActive ? filterBrowseMenuItems(items) : items}
          emptyText={MESSAGE.EMPTY_TOPICS}
          baseRoute={match.url}
          onClick={item => trackOwnerManualFolderClick(item.title)}
        />
      )}
    </BrowseGuideLayout>
  )
}

ArticlesTags.propTypes = {
  articles: PropTypes.array,
  match: PropTypes.object.isRequired,
  baseRoute: PropTypes.string,
}

function mapStateToProps({ contents: { publications } }) {
  const pubs = getPublicationsForVehicle(publications.toJS())
  const articles = getArticlesWithTags(pubs)

  return { articles }
}

export default connect(mapStateToProps)(ArticlesTags)
